import {Component, OnDestroy, OnInit} from '@angular/core';
import {AlertService} from '../../services/alert/alert.service';
import {Router} from '@angular/router';
import {UserService} from '../../services/user/user.service';
import {User} from '../../services/user/user';
import {LoadingService} from '../../services/loading/loading.service';
import {Subscription} from 'rxjs';
import AppConstants from '../common-components/AppConstants';
import {UserSelectionService} from '../user-selection/user-selection-service';

@Component({
    selector: 'app-app-terms-conditions',
    templateUrl: './app-terms-conditions.component.html',
    styleUrls: ['./app-terms-conditions.component.css'],
    standalone: false
})
export class AppTermsConditionsComponent implements OnInit, OnDestroy {
  isModalShown: Boolean = true;
  accepted: Boolean = false;
  public redirectUrl: string;
  currentUser: User | any;
  private user_subscription: Subscription;

  constructor(private alertService: AlertService, private router: Router, private userService: UserService, private loader: LoadingService, private userSelectionService: UserSelectionService) {
    debugger;
    this.user_subscription = this.userService.getCurrentUserDetails().subscribe(currentUser => {
      if (AppConstants.isNotNullCondition(currentUser)) {
        this.currentUser = currentUser;
        this.currentUser.isRoleSelected = false;
        debugger;
        // this.userService.removeUserSessionByUserId(this.currentUser);
        localStorage.setItem('currentUser', JSON.stringify(this.currentUser));
        this.userService.setUserObservable(this.currentUser);
      }
      this.loader.hide();
    }, error => {
      this.loader.hide();
      this.alertService.info('unable to get current user details');
    });
  }

  ngOnInit() {
  }

  acknowledge() {
    if (this.accepted === true) {
      this.isModalShown = false;
      if (AppConstants.isNotNullCondition(this.currentUser)) {
        if (this.currentUser.multiUserAccount) {
          this.redirectUrl = '/userselection';
          if (this.redirectUrl) {
            // using router navigation to navigate to landing page
            this.router.navigate([this.redirectUrl]);
            this.redirectUrl = null;
          }
        } else {
          this.userSelectionService.saveUSerRoleWithSession(AppConstants.constructUserSessionObject(this.currentUser)).subscribe(result => {
            this.currentUser.isRoleSelected = true;
            localStorage.setItem('currentUser', JSON.stringify(this.currentUser));
            this.userService.setUserObservable(this.currentUser);
            this.redirectUrl = '/landing';
            if (this.redirectUrl) {
              // using router navigation to navigate to landing page
              this.router.navigate([this.redirectUrl]);
              this.redirectUrl = null;
            }
            this.alertService.success('Successfully Logged In');
          }, error1 => {
            this.alertService.error('error saving the user session, please try again');
          });
        }
      }
    }
  }

  ngOnDestroy(): void {
    if (this.user_subscription) {
      this.user_subscription.unsubscribe();
    }
  }

}
